import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.progress.loading;
export const progressErrorMessage = (state: RootState) => state.progress.error;
export const progressDataResponse = (state: RootState) =>
  state.progress.progressResponse;
